/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';
import { SWITCH } from 'app/config';
import { FeatureConfig } from 'app/config/feature';

@Component({
    selector: 'app-lun-detail',
    templateUrl: './lun-detail.component.html',
})
export class LunDetailComponent {
    data;

    SWITCH = SWITCH;

    FeatureConfig = FeatureConfig;
}

